// Categorias de filtro do portefólio (labels PT/EN)
// NOTA: os projetos em si vivem na base de dados e gerem-se no F&L Admin (/admin).
export const PROJECT_CATEGORIES = [
  { key: 'all', pt: 'Todos', en: 'All' },
  { key: 'fotografia', pt: 'Fotografia', en: 'Photography' },
  { key: 'video', pt: 'Vídeo', en: 'Video' },
  { key: 'marketing', pt: 'Marketing', en: 'Marketing' },
  { key: 'websites', pt: 'Websites', en: 'Websites' },
  { key: 'souvenir', pt: 'Souvenir', en: 'Souvenir' },
];

export const projectUrl = (slug, lang) => `/${lang}/portfolio/${slug}`;
